// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import keyMirror from 'mattermost-redux/utils/key_mirror';

// The actions are created and triggered from the playbooks repository
export default keyMirror({
    PLAYBOOKS_PUBLISH_TEMPLATES: null,
});
